import React, { useState, useEffect } from 'react';

import styled from 'styled-components';


const PictureHolder = ( { mini, image } ) => {

  

  // useEffect(()=>{
    
  //   console.log('image:->');
  //   console.log(image);
    
  //   if(image) {
      
  //     if(!image.img_mini_name) {
  //       image.img_mini_name = image.img_name
  //       console.log('image:->');
  //       console.log(image);
  //     };
  //   };

  // },[image, image.img_mini_name])

  return (

    <ImageContainer className="PictureHolder--image-container">
      <img className="loaded-image"
        src={`${mini}${image.img_mini_name}`} 
        alt={image.img_mini_name} 
        title={image.img_mini_name}
      />
    </ImageContainer>

  )

}


export default PictureHolder;


const ImageContainer = styled.div `
    /* width: 200px; */
    /* max-height: 190px; */
    /* aspect-ratio: 4/3; */
    /* max-width: 170px; */
    height: 10px;
    width: 170px; 

    display: flex;
    align-items: center;

    
    
    img.loaded-image {
      position: relative;
      height: 130px;
      width: 170px; 
      object-fit: cover;
      image-orientation: from-image; 
      /* image-orientation: none;  */
    }

    
`;